import { useCallback, useEffect, useState } from "react";
import { apiGet } from "./http";
import type { TenantDto } from "./types";
import { getUserFacingMessage } from "./errors";

export function useTenants() {
  const [tenants, setTenants] = useState<TenantDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoading(true);
    setError(null);
    return apiGet<TenantDto[]>("/api/tenants")
      .then(setTenants)
      .catch((e) => {
        setError(getUserFacingMessage(e, "租户列表加载失败，请刷新。"));
        setTenants([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { tenants, setTenants, loading, error, reload };
}
